<template>
  <el-table-column :label="label" :prop="prop" class-name='date' :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '日付'
    },
    prop: {
      type: String,
      default: 'date'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.date {
      width: 9.5em;
    }
  }
}
</style>
